module.exports = __webpack_public_path__ + "static/media/free-stand-pic.c2bf34c3.png";